module.exports = __webpack_public_path__ + "static/media/typeFour.2f1309a7.png";